export class CustomerManagementCollections {
  static ModuleName = 'customer-management';
  static OffStreetModuleName = 'off-street-management';


  static CustomerProfiles = `${CustomerManagementCollections.ModuleName}/customer-profiles`;
  static customerProfile(customerProfileId: string) {
    return `${CustomerManagementCollections.CustomerProfiles}/${customerProfileId}`;
  }

  static customerProfileEligibleAccounts(customerProfileId: string) {
    return `${CustomerManagementCollections.customerProfile(customerProfileId)}/eligible-accounts`;
  }
  static customerProfileVehicles(customerProfileId: string) {
    return `${CustomerManagementCollections.customerProfile(customerProfileId)}/vehicles`;
  }

  static customerProfileOrders(customerProfileId: string) {
    return `${CustomerManagementCollections.customerProfile(customerProfileId)}/orders`;
  }

  static myWalletTransactions = `${CustomerManagementCollections.CustomerProfiles}/my/wallet-transactions`;
  static myWalletIncomes = `${CustomerManagementCollections.CustomerProfiles}/my/wallet-incomes`;

  static myOnStreetReservations = `${CustomerManagementCollections.CustomerProfiles}/my/on-street-reservations`;
  static myViolations = `${CustomerManagementCollections.CustomerProfiles}/my/violations`;

  static myOffStreetReservations = `${CustomerManagementCollections.CustomerProfiles}/my/off-street-reservations`;
  static offStreetReservations = `${CustomerManagementCollections.CustomerProfiles}/off-street-reservation`;


  static myOnStreetReservation(id: string) {
    return `${CustomerManagementCollections.myOnStreetReservations}/${id}`;
  }

  static myViolation(id: string) {
    return `${CustomerManagementCollections.myViolations}/${id}`;
  }

  static myInvoices = 'CustomerProfiles/my/invoices';
  static myInvoice(id: string) {
    return `CustomerProfiles/my/invoices/${id}`;
  }

  static myInvoiceByOrder(orderId: string) {
    return `CustomerProfiles/my/invoices/by-order/${orderId}`;
  }

  static myOffStreetReservation(id: string) {
    return `${CustomerManagementCollections.myOffStreetReservations}/${id}`;
  }

  static pickOffStreetReservation(code: string) {
    return `${CustomerManagementCollections.offStreetReservations}/pick/${code}`;
  }

  static customerSettleOffStreetReservation(code: string) {
    return `${CustomerManagementCollections.OffStreetModuleName}/end-users/off-street-reservations/${code}/customer/settle`;
  }

  static anonymousSettleOffStreetReservation(code: string) {
    return `${CustomerManagementCollections.OffStreetModuleName}/end-users/off-street-reservations/${code}/Anonymous/settle`;
  }

  static walletConfiguration = `${CustomerManagementCollections.ModuleName}/wallet-configuration`;
}
